import { Stack } from "@mui/material";
import { type Worker } from "@src/appV2/Worker/api/types";

import { TravelBlocks } from "./components/TravelBlocks";

interface TravelBlocksPageProps {
  worker: Worker;
}

export function TravelBlockPage(props: TravelBlocksPageProps) {
  const { worker } = props;

  return (
    <Stack sx={{ overflowY: "auto", height: "100%" }} flex={1} spacing={2}>
      <TravelBlocks worker={worker} />
    </Stack>
  );
}
